import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Checkbox } from '@bingads-webui-react/fabric-with-signal';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withValidation, withError, AdapterFactory } from '@bingads-webui-react/validation';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { ReactTemplate } from '@bingads-webui-react/react-template';

export const getAutoGeneratedAssetsDetails = (i18n, autoGeneratedAssetsEnabled) => (autoGeneratedAssetsEnabled ?
  i18n.getString(_TL_('On: Enable autogenerated assets')) :
  i18n.getString(_TL_('Off: Disable autogenerated assets')));

const AutoGeneratedAssetsValidationAdapter = AdapterFactory({
  convertEventToValue: event => event.target.checked,
  defaultValue: false,
  valueToInject: 'checked',
  functionToInject: 'onChange',
});

const getStyles = () => ({
  autoGeneratedAssets: {
    '& .ms-Checkbox-text': {
      fontWeight: 'bold',
    },

    '& .description': {
      marginLeft: 28,
    },
  },
});

const AutoGeneratedAssets = ({
  checked,
  onChange,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classNames(classes.autoGeneratedAssets, 'auto-generated-assets')}>
      <Checkbox
        id="checkbox-auto-generate-assets"
        label={i18n.getString(_TL_('Enable autogenerated assets for Responsive Search ads'))}
        checked={checked}
        onChange={onChange}
      />
      <div className="description">
        <ReactTemplate
          model={{ b: text => (<b>{text}</b>) }}
          template={i18n.getString(_TL_('By enabling this setting, Microsoft Advertising will automatically generate relevant assets.'))}
        />
        <LearnMoreLink
          linkText={i18n.getString(_TL_('Learn more'))}
          ariaLabel={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: i18n.getString(_TL_('Autogenerated assets')) })}
          topic="app54711"
        />
      </div>
    </div>
  );
};

AutoGeneratedAssets.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

AutoGeneratedAssets.defaultProps = {
  checked: false,
  onChange: undefined,
};

export const ValidatedAutoGeneratedAssets = withError(withValidation(AutoGeneratedAssets, AutoGeneratedAssetsValidationAdapter));
